import {Box, styled} from "@mui/material";
import React from "react";
import {Title} from "../Contacts/Contacts";
import AIDiagram from "./AIDiagram";
import AISummary from "./AISummary";

const AIContainer = styled(Box)({
    width: "100%",
    position: "relative",
    borderImage: "linear-gradient(90deg, #05080c, #6d7985, #05080c) 100",
    borderBottom: "2px solid",
    background: "radial-gradient(circle at -30% 80%, #6d7a83 0%,transparent 36%), radial-gradient(circle at 143% 10%, #6d7a83 0%,transparent 66%), #020508",
    "@media(max-width: 768px)":{
        background: "linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.5))",
    }
});

const AI = ():JSX.Element => {
    return (
        <AIContainer id={"aitechnology"}>
            <Title sx={{
                padding: "5px 0"
            }}>AI Technology:</Title>
            <AIDiagram/>
            <AISummary/>
        </AIContainer>
    );
};


export default AI;
